export const POLL_INTERVAL_MS = 2000;
export const INITIAL_CHECK_DELAY_MS = 2000;

export const STATUS_PAGO = 'pago';
export const STATUS_PROCESSANDO = 'processando';
export const STATUS_PENDING_CHALLENGE = 'Pending Challenge';
